import { AlertTriangle } from 'lucide-react';

import { Modal } from '@@/modals';
import { Widget } from '@@/Widget';
import { Icon } from '@@/Icon';

interface Props {
  isOpen: boolean;
  progressPercentage: number;
  elapsedTime: number;
}

export function RepositoryDeletionProgressModal({
  isOpen,
  progressPercentage,
  elapsedTime,
}: Props) {
  if (!isOpen) return null;

  return (
    <Modal onDismiss={() => {}} aria-label="Repository deletion progress">
      <Modal.Header title="Repository deletion in progress" />
      <Modal.Body>
        <Widget>
          <Widget.Body>
            <div className="small text-muted mb-1">
              <Icon
                icon={AlertTriangle}
                mode="warning"
                className="!mr-1 !inline"
              />
              Repository deletion is in progress! Closing your browser or
              refreshing the page while this operation is in progress will
              result in an incomplete operation.
            </div>
            <div>
              Deletion progress: {progressPercentage}% -{' '}
              {Math.round(elapsedTime)}s
            </div>
          </Widget.Body>
        </Widget>
      </Modal.Body>
    </Modal>
  );
}
